import { useState, useEffect } from 'react';

export const useOfflineReady = (): boolean => {
  const [isOfflineReady, setIsOfflineReady] = useState(false);

  useEffect(() => {
    const handleOfflineReady = (event: CustomEvent): void => {
      setIsOfflineReady(event.detail.ready);
    };

    // Listen for the custom offline ready event
    window.addEventListener('offlineReady', handleOfflineReady as EventListener);

    return () => {
      window.removeEventListener('offlineReady', handleOfflineReady as EventListener);
    };
  }, []);

  return isOfflineReady;
};
